<script lang="ts">
  import { LockOpen, Lock, X } from '@lucide/svelte';
  import { t } from '$lib/i18n';
  import type { ReviewState } from '@briefmarken_katalog/types';

  // `state` is destructured under a different name: a local binding called `state`
  // would make `$state(...)` below parse as a store subscription instead of a rune.
  const { state: reviewState, reviewedBy, currentUserId, userCanReview, onMarkAsInReview, onDropReview } = $props<{
    state: ReviewState;
    reviewedBy: string | null | undefined;
    currentUserId: string | undefined;
    userCanReview: boolean;
    onMarkAsInReview: () => void | Promise<void>;
    onDropReview: () => void | Promise<void>;
  }>();

  // Guards against a second click while the first request is still in flight —
  // the icon only changes once the server has answered, so without this a slow
  // response invites conflicting claim/release requests.
  let pending = $state(false);

  async function run(action: () => void | Promise<void>) {
    if (pending) return;
    pending = true;
    try {
      await action();
    } finally {
      pending = false;
    }
  }
</script>

{#if reviewState === 'Suggested'}
  {#if userCanReview}
    <button
      onclick={() => run(onMarkAsInReview)}
      disabled={pending}
      title={$t('review.markAsInReview')}
      class="px-1 cursor-pointer disabled:cursor-wait disabled:opacity-50"
    >
      <LockOpen size={16} color="black" />
    </button>
  {:else}
    <span title={$t('review.notInReview')} class="px-1">
      <LockOpen size={16} color="black" />
    </span>
  {/if}
{:else if reviewState === 'InReview' && reviewedBy !== currentUserId}
  <span title={$t('review.inReviewByOther')} class="px-1">
    <Lock size={16} color="red" />
  </span>
{:else if reviewState === 'InReview' && reviewedBy === currentUserId}
  <button
    onclick={() => run(onDropReview)}
    disabled={pending}
    title={$t('review.inReviewByYouClickToDrop')}
    class="px-1 cursor-pointer disabled:cursor-wait disabled:opacity-50"
  >
    <Lock size={16} color="green" />
  </button>
{:else if reviewState === 'Rejected'}
  <span title={$t('review.rejected')} class="px-1">
    <X size={16} color="red" />
  </span>
{/if}
